import { createSelector } from '@reduxjs/toolkit'

export const getVehicle = state => state.vehicle

export const selectVehicleImages = createSelector([getVehicle], vehicle => {
  return [...(vehicle.exteriorImages || []), ...(vehicle.interiorImages || [])]
})

export const selectSelectedVehiclePaintOption = createSelector(
  [getVehicle],
  vehicle => vehicle.selectedPaintOption,
)

export const selectPaintOptions = createSelector([getVehicle], vehicle => vehicle.paintOptions)

export const selectVehicleForPaintOption = createSelector(
  [getVehicle],
  vehicle => vehicle.paintOptionVehicle,
)
